module.exports = __webpack_public_path__ + "images/partner2.6336a230.svg";